/* eslint-disable react/prop-types, prefer-arrow-callback */
import * as React from "react";
import PropTypes from "prop-types";
import { LinkProvider as LinkProviderV5 } from "@lululemon/ecom-pattern-library";
import { LinkProvider as LinkProviderV6 } from "@lululemon/ecom-pattern-library-link-provider";
import { LinkProvider as LinkProviderUI } from "@lululemon/ui-library";
/*
 * Temporary implementation using LinkGenerator;
 * actual implementation using NextRoutesDynamicLink will be completed in COSY-1116.
 */
import LinkGenerator from "@lululemon/ecom-common/src/lib/link-generator";

/*
 * The shouldUseV6Provider prop should be removed once the PL migration to v6 is completed,
 * and keep using only LinkProvider from @lululemon/ecom-pattern-library-link-provider.
 */
const DynamicLinkProvider = ({ children, shouldUseV6Provider, ...rest }) => {
  const LinkProvider = shouldUseV6Provider ? LinkProviderV6 : LinkProviderV5;

  const LinkComponent = React.forwardRef(function LinkProviderWithForwardRef(
    { href, ...props },
    ref
  ) {
    const analyticsAttrs = {
      "data-categoryunifiedid": props?.["data-categoryunifiedid"],
      "data-lulu-attributes": props?.["data-lulu-attributes"],
      "data-lulu-track": props?.["data-lulu-track"],
      "data-productid": props?.["data-productid"],
      "data-skuid": props?.["data-skuid"],
    };

    return (
      <LinkGenerator
        href={href}
        analyticsAttrs={analyticsAttrs}
        linkRef={ref}
        {...props}
        {...rest}
      />
    );
  });

  return (
    <LinkProviderUI component={LinkComponent}>
      <LinkProvider component={LinkComponent}>{children}</LinkProvider>
    </LinkProviderUI>
  );
};

DynamicLinkProvider.defaultProps = {
  shouldUseV6Provider: false,
};

DynamicLinkProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  shouldUseV6Provider: PropTypes.bool,
};

export default DynamicLinkProvider;
